import { defineComponent as _defineComponent } from 'vue'
import { formatDuration } from '@/utils/date-formatting'
import { computed, onUnmounted, ref, watchEffect } from 'vue'
import { Stage } from '@/api/pools'
import moment from 'moment'
import PoolStageAvailability from '@/components/tickets/PoolStageAvailability.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PoolStage',
  props: {
    stage: null
  },
  emits: ['expired'],
  setup(__props: any, { emit }) {

const props = __props as { stage: Stage }

const timeRemaining = ref()
const interval = ref()

const dueBy = computed(() =>
  props.stage.due_by ? moment.utc(props.stage.due_by) : null
)




const isFailed = computed(() =>
  props.stage.availability.every((a) => a.status === 'NotAvailable')
)

const statusText = computed(() => {
  if (isFailed.value) {
    return 'Not Available'
  }
  if (props.stage.status === 'AvailabilityRequested') {
    return 'Awaiting Availability'
  }
  if (props.stage.status === 'UpNext') {
    return 'Up Next'
  }

  return props.stage.status
})

const statusColor = computed(() => {
  if (isFailed.value) {
    return 'var(--color-red--light)'
  }
  if (props.stage.status === 'AvailabilityRequested') {
    return 'var(--color-green)'
  }

  return 'var(--color-blue)'
})

const statusIcon = computed(() => {
  if (isFailed.value) {
    return 'mdi-close'
  }
  if (props.stage.status === 'AvailabilityRequested') {
    return 'mdi-email-arrow-right-outline'
  }
  if (props.stage.status === 'Queued') {
    return 'mdi-clock-outline'
  }

  return null
})

watchEffect(() => {
  if (!props.stage.due_by) {
    return
  }
  if (interval.value) {
    clearInterval(interval.value)
  }
  interval.value = setInterval(() => {
    if (!dueBy.value) {
      return
    }
    if (props.stage.status !== 'UpNext') {
      timeRemaining.value = null
      clearInterval(interval.value)
      return
    }
    const duration = moment.duration(dueBy.value.diff(moment.utc()))
    if (duration.asMilliseconds() <= 0) {
      emit('expired')
      clearInterval(interval.value)
      timeRemaining.value = null
      return
    }

    timeRemaining.value = formatDuration(duration)
  }, 1000)
})

onUnmounted(() => {
  clearInterval(interval.value)
})

return { __sfc: true,timeRemaining, interval, dueBy, props, emit, isFailed, statusText, statusColor, statusIcon, PoolStageAvailability }
}

})